var map = {
	"./404.svg": "fe52",
	"./bug.svg": "b074",
	"./chart.svg": "bcf4",
	"./clipboard.svg": "881e",
	"./component.svg": "dc41",
	"./dashboard.svg": "7315",
	"./documentation.svg": "ec0a",
	"./drag.svg": "2bca",
	"./edit.svg": "9949",
	"./education.svg": "bc24",
	"./email.svg": "a0ae",
	"./example.svg": "a4fec",
	"./excel.svg": "b0e6",
	"./exit-fullscreen.svg": "d5b1",
	"./eye-open.svg": "e45a",
	"./eye.svg": "cfd8",
	"./form.svg": "dfe2",
	"./fullscreen.svg": "db08",
	"./guide.svg": "e9af",
	"./icon.svg": "0303",
	"./international.svg": "0b80",
	"./language.svg": "ce92",
	"./link.svg": "5145",
	"./list.svg": "35a5",
	"./lock.svg": "ae58",
	"./message.svg": "2afd",
	"./money.svg": "e280",
	"./nested.svg": "a739",
	"./password.svg": "dfec",
	"./pdf.svg": "43c1",
	"./people.svg": "b334",
	"./peoples.svg": "0d90",
	"./qq.svg": "fa52",
	"./search.svg": "84b9",
	"./shopping.svg": "2f22",
	"./size.svg": "b449",
	"./skill.svg": "f068",
	"./star.svg": "a7d6",
	"./tab.svg": "bad6",
	"./table.svg": "df11",
	"./theme.svg": "3007",
	"./tree-table.svg": "4395",
	"./tree.svg": "04b2",
	"./user.svg": "8f01",
	"./wechat.svg": "769c",
	"./zip.svg": "6f4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95ff";